import {useListingService} from "@hosttools/frontend";
import type {AccountChannelType} from "@hosttools/frontend/models/account";
import type {Listing} from "@hosttools/frontend/models/listing";
import {useQuery} from "@tanstack/react-query";
import {useCallback, useMemo} from "react";

interface Payload {
    listingID?: string;
    channel?: AccountChannelType;
}

const useListingObjectFromChannel = ({listingID, channel}: Payload) => {
    const listingService = useListingService();

    const {data, isLoading} = useQuery({
        queryKey: ["/listingObjFromChannel", listingID, channel],
        enabled: !!listingID && !!channel,
        queryFn: useCallback(async () => {
            if (!listingID || !channel) {
                return Promise.resolve(null);
            }
            return listingService.post("/listingObjFromChannel", {
                listingID,
                channel
            });
        }, [listingID, channel, listingService])
    });

    const listing = useMemo(() => {
        if (!data) {
            return undefined;
        }
        const {userID, ...rest} = data;
        const listing: Partial<Listing> = {
            ...rest
        };
        return listing;
    }, [data]);

    return {
        listing,
        isLoading
    };
};

export default useListingObjectFromChannel;
